<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="name"
      :search="search"
      class="elevation-0 general-table"
      :loading="isLoading"
      :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
    >
      <template v-slot:header.name="{ header }">
        <lang t="USER_MANAGEMENT-TBL-HEADER-NAME"></lang>
      </template>

      <template v-slot:header.mandate="{ header }">
        <lang t="USER_MANAGEMENT-TBL-HEADER-MANDATE"></lang>
      </template>

      <template v-slot:header.email="{ header }">
        <lang t="USER_MANAGEMENT-TBL-HEADER-EMAIL"></lang>
      </template>

      <template v-slot:header.language.shortcode="{ header }">
        <lang t="USER_MANAGEMENT-TBL-HEADER-LANGUAGE"></lang>
      </template>

      <template v-slot:header.unitSystem="{ header }">
        <lang t="USER_MANAGEMENT-TBL-HEADER-UNIT_SYSTEM"></lang>
      </template>

      <template v-slot:header.role="{ header }">
        <lang t="USER_MANAGEMENT-TBL-HEADER-ROLE"></lang>
      </template>

      <template v-slot:footer.page-text="props" v-if="items.length > 0">
        <display-number :number="props.pageStart" />-<display-number :number="props.pageStop" /> {{ $t("of") }}
        <display-number :number="items.length" />
      </template>

      <template v-slot:top>
        <div class="d-flex align-center flex-wrap py-2 mb-6">
          <v-text-field
            clearable
            class="general-table__search"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            :label="$t('GLOBAL-DO_SEARCH')"
            solo
            flat
            dense
            hide-details
          />

          <v-spacer></v-spacer>

          <Button type="outside-label" icon="mdi-plus" :label="$t('USER_MANAGEMENT-BTN-NEW_USER')" @click="addUser" />
        </div>
      </template>

      <template v-slot:item.mandate="{ item }">
        {{ item.mandate != null && typeof item.mandate.name != "undefined" ? item.mandate.name : "-" }}
      </template>

      <template v-slot:item.role="{ item }">
        <lang :t="'USER-ROLE-' + item.role.toUpperCase()"></lang>
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-center">
          <v-icon small class="pa-1" color="grey darken-2" @click.stop="editItem(item)">mdi-pencil</v-icon>
          <v-icon small class="pa-1" color="grey darken-2" @click.stop.prevent="deleteItem(item)" :disabled="!item.isDeleteable"
            >mdi-trash-can-outline</v-icon
          >
        </div>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Button from "../../components/ui-elements/Button.vue";
import DisplayNumber from "../../components/DisplayNumber.vue";

export default {
  components: {
    Button,
    DisplayNumber,
  },
  data: () => ({
    isLoading: true,

    search: "",

    headers: [
      { text: "Name", align: "start", value: "name", sortable: true, class: "general-table__th--6" },
      { text: "Mandate", value: "mandate", sortable: true, class: "general-table__th--6", sort: (a, b) => {
        const aName = a && a.name? a.name: '-';
        const bName = b && b.name? b.name: '-';
        if(aName > bName) return 1;
        if(aName < bName) return -1;
        return 0;

      } },
      { text: "E-Mail", value: "email", sortable: true, class: "general-table__th--6" },
      { text: "Language", value: "language.shortcode", sortable: true, class: "general-table__th--6" },
      { text: "Unit System", value: "unitSystem", sortable: true, class: "general-table__th--6" },
      { text: "Role", value: "role", sortable: true, class: "general-table__th--6" },
      { text: "", value: "actions", sortable: false, width: "80px", align: "end" },
    ],

    items: [],
  }),

  created() {
    this.initialize();
  },

  mounted() {},

  methods: {
    initialize() {
      this.isLoading = true;

      this.axios.get("users").then((res) => {
        this.items = res.data;
        this.isLoading = false;
      });
    },

    addUser() {
      this.$router.push({ name: "newUser" });
    },

    editItem(item) {
      this.$router.push({ name: "user", params: { id: item.id } });
    },

    deleteItem(item) {
      this.$confirm(this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { NAME: item.name }), {
        title: this.$t("GLOBAL-CONFIRMATION-DELETE-TITLE"),
        buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
        buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
      }).then((res) => {
        if (res) {
          this.axios.delete("users/" + item.id).then((res) => {
            this.initialize();
            this.$store.dispatch("setSnackbar", { text: this.$t("GLOBAL-SUCCESSFULLY_DELETED") });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
